import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=25885cd4&"
import script from "./PageHeading.vue?vue&type=script&lang=js&"
export * from "./PageHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports